import React from "react";
import { Card } from "antd";

const ImageViewer = React.memo(({ base64, type = "png" }: { base64: string; type?: string }) => {
    if (!base64) {
        return <Card>Image not found.</Card>;
    }

    const imageDataUri = `data:image/${type};base64,${base64}`;

    return (
        <Card title="Image Viewer" bordered style={{ maxHeight: "520px", overflow: "auto" }}>
            <img
                src={imageDataUri}
                alt="Base64 Document"
                style={{
                    maxWidth: "100%",
                    maxHeight: "480px",
                    display: "block",
                    margin: "0 auto",
                    border: "1px solid #eee",
                    borderRadius: "8px",
                    boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                }}
            />
        </Card>
    );
});

export default ImageViewer;


// import { useEffect } from "react";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
// import { Card } from 'antd';
// import React from "react";

// const ImageViewer = React.memo(({ base64 }: { base64: string }) => {

//     if (!base64) {
//             return <Card>Image not found.</Card>;
//         }

//     const imageDataUri = `data:image/png;base64,${base64}`; // Change to `image/jpeg` or other formats if needed
//     const key = "image" + Math.random();
//     const documents = [
//         {
//             uri: imageDataUri, // Pass the Base64 image as a data URI
//         },
//     ];

//     return (
//         <div style={{ border: "1px solid #ccc", padding: "10px", height: "500px" }}>
//             <DocViewer
//                 key={key}
//                 documents={documents}
//                 pluginRenderers={DocViewerRenderers}
//                 config={{
//                     header: {
//                         disableHeader: true, // Optional: Disable header for simplicity
//                     },
//                 }}
//             />
//         </div>
//     );
// });

// export default ImageViewer;



// const ImageViewer = ({ filePath, base64 }: { filePath: string, base64: string }) => {
//     //const imageDataUri = `data:image/png;base64,${base64}`; // Change to `image/jpeg` or other formats if needed
//     let url = "";

//     if (filePath) {
//         url = filePath;
//     }
//     else {
//         url = `data:image/png;base64,${base64}`;
//     }


// const documents = [
//     {
//         uri: url, // Pass the Base64 image as a data URI
//     },
// ];